import { map } from 'rxjs/operators';
import { VIEW_METADATAUPDATED } from '@tv2-player/unifiedplayer/src/core/events';
import merge from 'lodash/merge';
import { UnifiedPlayer } from '@tv2-player/unifiedplayer/src/types';
import { SeekInformationValue } from '@tv2-player/unifiedplayer/src/util/seekable';
import { PlayerManager } from '../types/chromecast-caf-receiver/cast.framework';
import cast from '../types/chromecast-caf-receiver';

/**
 * This function is responsible for updating the media information in the player.
 * It observes the `VIEW_METADATAUPDATED` event from the player and updates the media information accordingly.
 *
 * @param {UnifiedPlayer} player - The player instance from which the media information is to be updated.
 * @param {PlayerManager} playerManager - The player manager instance which manages the media information.
 * @returns An Observable that emits the updated media information.
 */
export default function updateMediaInformationHandler(
  player: UnifiedPlayer,
  playerManager: PlayerManager
) {
  const { GenericMediaMetadata, MediaInformation } = cast.framework.messages;
  const metadata$ = player.observe<SeekInformationValue>(VIEW_METADATAUPDATED);
  return metadata$.pipe(
    // Map the metadata to a new GenericMediaMetadata object
    map(metadata =>
      Object.assign(new GenericMediaMetadata(), {
        title: metadata.epgTitle,
        sectionStartAbsoluteTime: metadata.start,
        sectionDuration: metadata.duration,
      })
    ),
    // Merge the new metadata with the existing media information
    map(containerMetadata => {
      const mediaInformation = playerManager.getMediaInformation();
      const { metadata } = mediaInformation ?? {};
      return Object.assign(new MediaInformation(), {
        ...mediaInformation,
        metadata: merge(metadata, containerMetadata),
      });
    })
  );
}
